import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ShipperAccountReferenceService extends BaseReferenceService {
  constructor() {
    super('ShipperAccountReference');
  }
}
